/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Ozellik_TalebiInputs */

const tr_faq_a_ozellik_talebi = /** @type {(inputs: Faq_A_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yardım sayfasındaki geri bildirim formunu kullanabilir ya da destek ekibine doğrudan yazabilirsin. Talepleri yol haritamızda değerlendiriyoruz; en çok istenen özellikler önceliğe alınıyor. Mevcut yol haritamızı takip etmek istersen destek kanalımıza katılabilirsin.`)
};

const en_faq_a_ozellik_talebi = /** @type {(inputs: Faq_A_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the feedback form on the Help page or write directly to our support team. We review all requests and prioritize the most requested ones. Join the support channel to follow what is coming next.`)
};

const de_faq_a_ozellik_talebi = /** @type {(inputs: Faq_A_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze das Feedback-Formular auf der Hilfe-Seite oder schreibe direkt an unser Support-Team. Wir prüfen alle Anfragen und priorisieren die meistgefragten Funktionen. Tritt unserem Supportkanal bei, um zu verfolgen, was als Nächstes kommt.`)
};

const ru_faq_a_ozellik_talebi = /** @type {(inputs: Faq_A_Ozellik_TalebiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте форму обратной связи на странице Помощь или напишите напрямую в поддержку. Мы рассматриваем все запросы и приоритизируем наиболее востребованные функции. Присоединяйтесь к нашему каналу поддержки, чтобы следить за новинками.`)
};

/**
* | output |
* | --- |
* | "Use the feedback form on the Help page or write directly to our support team. We review all requests and prioritize the most requested ones. Join the support..." |
*
* @param {Faq_A_Ozellik_TalebiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_ozellik_talebi = /** @type {((inputs?: Faq_A_Ozellik_TalebiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Ozellik_TalebiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_ozellik_talebi(inputs)
	if (locale === "de") return de_faq_a_ozellik_talebi(inputs)
	if (locale === "ru") return ru_faq_a_ozellik_talebi(inputs)
	return tr_faq_a_ozellik_talebi(inputs)
});